import cx from 'classnames';
import { AI_STUDIO_SOURCE, buildAIStudioUrl } from '../helpers/aiStudioHelper';
import React, { memo, useEffect, useMemo, useRef, useState } from 'react';
import { Download, FooterButton, Preview, SharePopup } from '../common';
import { EditWithAIFooterButton } from '../common/EditWithAIMenu';
import {
  ADMIN_DASHBOARD,
  MY_FILES_SHARED_FILES_ROUTE,
  RENDERS_PREVIEWS_ROUTE,
  RENDERS_PREVIEWS_ROUTE_V2,
  RENDER_DETAILS,
  RENDER_DETAILS_V2,
  SHARED_FILES_ROUTE,
} from '../constants/routePathConstants';
import {
  getCollectionPath,
  getCuratorRenderPreviewPath,
  getCuratorRenderPreviewPathForMattress,
  isCuratorPage,
} from '../helpers/urlHelper';
import { useParams, useNavigate, useSearchParams, useLocation } from 'react-router-dom';
import {
  apiGetPreviewAndMainRender,
  apiToggleFavorite,
  apiGetRenderBasedOnProjectRenderId,
  apiEditRenderPreview,
  apiRetryRenderPreview,
  apiArchiveRender,
  apiGetImageMeasurementData,
  apiUpdateUserDetails,
  apiCreateRender,
} from '../helpers/api';
import { jpegFileFromBlobUrl } from '../api/curator';
import {
  uploadGenerativeAIFile,
  getCachedGenerativeAIUpload,
} from '../helpers/generativeAIUpload';
import _ from 'lodash';
import { Form } from 'react-bootstrap';
import { DOWNLOAD_ICON } from '../constants/assetConstants';
import { icons } from '../assets';
import { EDIT_IMAGE_TOOL_OPTIONS, EDIT_IMAGE_TOOLS, MODEL_TYPES, MODULE_TYPES } from '../constants/constants';
import constants from '../constants/constants';
import domtoimage from 'dom-to-image-more';
const {
  CollectionIcon,
  EditIconV3,
  ImagineLogo,
  FullScreenIcon,
  HeartLineIcon,
  HeadsetIcon,
  ShareIcon,
  HeartIcon,
  BinIcon,
  RetryIcon,
  DimensionToolIconV2,
  ReRenderIcon,
} = icons;
import { errorToast, successToast, warningToast } from '../helpers/toastHelper';
import { RenderPageDialog } from '../common';
import {
  getImageDetails,
  handleScrollPage,
  objectToFormData,
  setTitle,
  wait,
  windowOpen,
} from '../helpers/jsHelper';
import { saveAs } from 'file-saver';
import JSZip from 'jszip';
import JSZipUtils from '../../node_modules/jszip-utils/dist/jszip-utils.js';
import { FinalRenderIcon } from '../components/icons/FinalRenderIcon';
import {
  checkIfEmailIsVerifiedOrNotFromApi,
  checkIfMemberHaveEditorAccess,
  useUserContext,
} from '../contexts/UserContext';
import { useDispatch, useSelector } from 'react-redux';
import {
  addToCollection,
  selectAddToCollectionModelType,
} from '../redux/slicers/addToCollectionPopupSlicer';
import AddToCollectionPopup from '../common/AddToCollectionPopup';
import { RestoreIcon } from '../components/icons/RestoreIcon';
import {
  myRenderPreviewActions,
  myRenderPreviewSelectors,
} from '../redux/slicers/render_preview/myRenderPreviewSlice';
import { useInfoDialogaActions } from '../hooks/useInfoDialogaActions';
import { usePermissionsHandler, useStaticPermissions } from '../hooks/usePermissions';
import { PERMISSION } from '../constants/permissionConstants';
import { download } from '../common/DownloadFileController/downloadFile';
import { isAdminOrOwner } from '../helpers/userHelper';
import { getAppState } from '../redux/store';
import { useDataListContext } from '../contexts/DataListContext';
import Loader from '../components/Loader/Loader';
import { createTicketModalActions } from '../redux/slicers/createTicketModalSlicer';
import { RAISE_TICKET_DEFAULTS, RAISE_TICKET_PLACEHOLDER } from '../constants/projectConstants';
import { InviteModal } from '../components/admin/curator/RenderPreviewsDialog/InviteModal';
import { selectPopupType } from '../redux/slicers/camera/renderPreviewPoppupSlicer';
import FinalProgressModal from '../components/gamifyOnBoarding/FinalProgressModal';
import ShareImage from '../components/gamifyOnBoarding/ShareImage';
import {
  GAMIFIED_STEPS,
  gamifyBoardingActions,
  selectFinalProgressStage,
  selectIsFinalProgress,
  selectIsGamifiedDialogOpen,
  selectShareImageModal,
  STAGE,
} from '../redux/slicers/gamifySlicer';
import {
  selectAllLineValues,
  selectImageMeasurementData,
  selectIsMeasureTool,
  selectMeasureToolStyle,
  measureToolActions,
  selectMeasureToolLoading,
} from '../redux/slicers/measureToolSlicer.js';
import { infoDialogSelector } from '../redux/slicers/infoDialogSlicer';
import {
  IMAGE_TYPE,
  IMAGE_VARIATION_TYPE,
  PASS,
  RENDER_IMAGE_TYPE,
} from '../constants/renderPreviewConstants';
import { Mixpanel, MxEvent } from '../common/Mixpanel';
import { history } from '../history';
import { useSwitchOrgToggle } from '../hooks/useRedirectPageOnSwitchOrg';
const { RENDER_STATUS } = constants;
import { MeasureToolContainer } from '../common/MeasureTool/MeasureToolContainer.js';
import { dispatcher } from '../helpers/projectHelper.js';
import { MagicToolIcon } from '../assets/icons.js';
import { setSignupPopOpen, setSignupPopOpenedFrom } from '../redux/slicers/uiSlicer.js';
import { selectGuestSignupComplete } from '../redux/slicers/admin/curatorSlicer.js';
import { userPilotEvents } from '../common/Userpilot/userpilotHelper.js';
import useCurrentOrganizationInfo from '../hooks/useCurrentOrganizationInfo.js';
import { selectCreatedCollectionList } from '../redux/slicers/admin/paginatedRenderPreviewsSlicer.js';
import { RiImageEditFill } from 'react-icons/ri';
import { handleDownloadEditedImage } from '../components/EditImageTool.js';
import { hasPostEditImage, postEditExtension } from '../helpers/postEditImageHelper';
import { downloadFileAsJPEG, downloadEditedImage } from '../api/curator.js';

const tagsConfig = {
  [RENDER_STATUS.STATUS_DISABLED]: {
    type: 'disabled',
    label: 'Disabled',
  },
  [RENDER_STATUS.STATUS_FAILED]: {
    type: 'error',
    label: 'Failed',
  },
  [RENDER_STATUS.STATUS_NOT_DONE]: {
    type: 'pending',
    label: 'Queued',
  },
  [RENDER_STATUS.STATUS_PROCESSING]: {
    type: 'secondary',
    label: 'Processing',
  },
};

const RenderDetails = memo(
  ({
    id,
    onClose,
    theme,
    sidebarProps,
    previewProps,
    hideAutoEraseWarning,
    onDataFetched,
    onDeleteSuccess,
    onDataUpdated,
    onRenderSuccess,
    ignoreAddToCollectionPopup,
    onRenderSwitch,
    renderStatusType = '',
    isAutomation = false,
  }) => {
    const [loadPage, switchOrgToggle] = useSwitchOrgToggle(false);
    const dataListContext = useDataListContext();
    const navigate = useNavigate();
    let cardType = 'render-details';
    const params = useParams();
    const location = useLocation();
    id = id || params.renderId;
    const collectionId = params.collectionId;
    const dispatch = useDispatch();
    const [pageLoading, setPageLoading] = useState(false);
    const {
      currentUser,
      updateUserData,
      isGuestUser,
      isGuestLogin,
      freeCredits,
      isEditor,
      canAccessLiveOnApp,
    } = useUserContext();
    const userName = currentUser?.user?.name;
    const currentOrg = currentUser?.organization;
    const [data, setData] = useState(null);
    const [cameraList, setCameraList] = useState([]);
    const [slides, setSlides] = useState([]);
    const [activeIndex, setActiveIndex] = useState(0);
    const [activeCameraId, setActiveCameraId] = useState(null);
    const [loading, setLoading] = useState(false);
    // const [showComments, setShowComments] = useState(false);
    const [isDownloadSingleImage, setDownloadSingleImage] = useState(false);
    const [showDownload, setShowDownload] = useState(false);
    const [showRender, setShowRender] = useState(false);
    const [downloadXPos, setDownloadXPos] = useState(0);
    const [includePasses, setIncludePasses] = useState(false);
    const [favouriteLoading, setFavouriteLoading] = useState(false);
    const [downloadLoading, setDownloadLoading] = useState(false);
    const [reRenderLoading, setReRenderLoading] = useState(false);
    const [retryLoading, setRetryLoading] = useState(false);
    const [restoreLoading, setRestoreLoading] = useState(false);
    const [renderedData, setRenderedData] = useState(null);
    const [imageUrl, setImageUrl] = useState([]);
    const [isFullScreenOn, setFullScreenOn] = useState(false);
    const [magicToolLoading, setMagicToolLoading] = useState(false);
    const { openInfoDialog } = useInfoDialogaActions();
    const [memberDetails, setMemberDetails] = useState({});
    const [removeOrBuyLoading, setRemoveOrBuyLoading] = useState(false);
    const isCollectionModelActive = useSelector(selectAddToCollectionModelType);
    const { handlePermissionEvent } = usePermissionsHandler();
    const [searchParams, setSearchParams] = useSearchParams();
    const isGamifiedDialogOpen = useSelector(selectIsGamifiedDialogOpen);
    const isShareImageModalOpen = useSelector(selectShareImageModal);
    const infoDialogOpen = useSelector(infoDialogSelector)?.config?.show;
    const [shareModal, setShareModal] = useState(false);
    const render_type = renderStatusType || searchParams.get('render_type');
    const cameraNameParam = searchParams.get('cameraName');
    const organization = searchParams.get('organization');
    const _isAutomation =
      isAutomation ||
      (!isCuratorPage() && searchParams.get('automation')?.toLowerCase() === 'true');
    const popupType = useSelector(selectPopupType);
    const parentPageTitle = document.title;
    const [activeCameraName, setActiveCameraName] = useState('');
    const [showMeasureTool, setShowMeasureTool] = useState(false);
    const [showEditImageTool, setShowEditImageTool] = useState(false);
    const [imageToolData, setImageToolData] = useState({[EDIT_IMAGE_TOOLS.COLOR_CORRECTION]: {value: 0, originalValue: 0}});
    const isMeasureToolActive = useSelector(selectIsMeasureTool);
    const allLineValues = useSelector(selectAllLineValues);
    const isFilmicImgType = data?.img_type === RENDER_IMAGE_TYPE.FILMIC;
    const allStyleSectionData = useSelector(selectMeasureToolStyle);
    const lineValues = useSelector(selectAllLineValues);
    const initialMeasureToolStyle = {
      lineSize: 2,
      lineColor: '#030303',
      textSize: 10,
      textColor: '#030303',
      textStyle: null,
      layout: 'inline',
      edgeAngle: null,
    };
    const measureToolLoading = useSelector(selectMeasureToolLoading);
    const [isMeasureDataPresent, setIsMeasureDataPresent] = useState(false);
    const [showRemoveWatermarkPopup, setShowRemoveWatermarkPopup] = useState(false);
    const isGuestSignupComplete = useSelector(selectGuestSignupComplete);
    const collectionList = useSelector(selectCreatedCollectionList);
    const [showPopup, setShowPopup] = useState(false);
    const { isFreemiumUser } = useCurrentOrganizationInfo();
    const { hasPermission } = useStaticPermissions();
    const [pass, setPass] = useState('1');
    const [editedImages, setEditedImages] = useState({})
    const [editImageLoading, setEditImageLoading] = useState(false);

    const isMountedRef = useRef(true);
    useEffect(() => {
      isMountedRef.current = true;
      return () => {
        isMountedRef.current = false;
      };
    }, []);

    const {
      trackDownloadImageClicked,
      trackBuyImageClicked,
      trackDownloadCurrentImageSelected,
      trackDownloadImageSuccess,
      trackDownloadIncludePassesSelected,
      trackClickEvent,
    } = userPilotEvents();

    const sidebarCards = useMemo(() => {
      return data?.images
        ? data.images.map((image) => ({
          ...image,
          thumbnail: isFilmicImgType
            ? image?.filmic_thumbnail || image?.thumbnail
            : image?.thumbnail,
          name: image.angle_name,
        }))
        : [];
    }, [data]);
    /**
     * Original/Post Edit is a viewing choice, not an editing one: an image that
     * carries saved edits offers both passes to everyone, so a viewer without
     * PERMISSION.IMAGE_EDITOR still sees - and downloads - the picture as it
     * was edited. Only the editor's own actions stay behind the permission.
     * Takes one camera or a whole list, for the surfaces that cover a render.
     */
    const usesEditPasses = (images) =>
      hasPermission(PERMISSION.IMAGE_EDITOR) || [].concat(images || []).some(hasPostEditImage);

    /**
     * The pass a camera opens on: the edited picture when it has one, the
     * render as produced for an editor, and the render's own img_type for
     * everyone else.
     */
    const defaultPassFor = (image, render) => {
      if (hasPostEditImage(image)) return PASS.POST_EDIT;
      if (hasPermission(PERMISSION.IMAGE_EDITOR)) return PASS.ORIGINAL;
      return render?.img_type === RENDER_IMAGE_TYPE.FILMIC ? PASS.FILMIC : PASS.STANDARD;
    };

    const isUpload = data?.is_upload;
    const isArchived = data?.is_archived;
    const isOldObj = data?.is_old_obj;
    const isTutorialExperience = data?.is_tutorial_experience;
    let passOptions = [];
    if (data?.images && data.images.length > 0 && !isUpload && !render_type) {
      const image = data?.images?.[activeIndex];
      if (usesEditPasses(image)) {
        if (hasPostEditImage(image)) {
          passOptions.push({
            name: "Original",
            value: PASS.ORIGINAL,
          },
            {
              name: "Post Edit",
              value: PASS.POST_EDIT,
            },
          )
        }
        else {
          passOptions.push({
            name: "Render",
            value: PASS.ORIGINAL,
          }
          )
        }
      }
      else {
        if (image?.file)
          passOptions.push({
            name: `Standard${!isFilmicImgType ? ' *' : ''}`,
            value: PASS.STANDARD,
          });
        if (image?.filmic_file)
          passOptions.push({
            name: `Filmic${isFilmicImgType ? ' *' : ''}`,
            value: PASS.FILMIC,
          });
      }
      if (image?.color_pass_file) passOptions.push({ name: 'Color', value: PASS.COLOR });
    }

    const closeDialog = () => navigate(ADMIN_DASHBOARD);

    useEffect(() => {
      if (loadPage) {
        switchOrgToggle();
      }
    }, [currentOrg]);

    useEffect(() => {
      if (showRemoveWatermarkPopup && isGuestSignupComplete) {
        setShowRemoveWatermarkPopup(false);
        toggleRenderArea(null, 'None');
      }
    }, [isGuestSignupComplete, showRemoveWatermarkPopup]);

    const resetState = () => {
      setActiveIndex(0);
      setCameraList([]);
      setSlides([]);
      setActiveCameraId(null);
      setDownloadSingleImage(false);
      setPass('1');
      setShowDownload(false);
      setShowRender(false);
      setDownloadXPos(0);
      setIncludePasses(false);
      setFavouriteLoading(false);
      setDownloadLoading(false);
      setRetryLoading(false);
      setRestoreLoading(false);
      setRenderedData(null);
      setFullScreenOn(false);
    };

    const isImageProgressActive = useSelector(selectIsFinalProgress);
    const urlParams = new URLSearchParams(location.search);
    const isOnboarding = urlParams.get('isOnboarding') || false;

    useEffect(() => {
      if (!isOnboarding || isImageProgressActive) return;
      let timer = null;
      if (timer) {
        clearTimeout(timer);
      }
      timer = setTimeout(() => {
        dispatch(gamifyBoardingActions.setGamifiedCurrentStep(GAMIFIED_STEPS.SAVE));
        dispatch(gamifyBoardingActions.openGamifiedDialog(true));
      }, 10000);
      return () => clearTimeout(timer);
    }, [isOnboarding, isImageProgressActive]);

    useEffect(() => {
      updateUserData();
      resetMeasurementLines();
      if (organization && currentOrg.toString() !== organization.toString()) {
        openInfoDialog({
          onClose: closeDialog,
          title: 'Not Found',
          description:
            'This render/preview was created from a different organization. Please switch your organization to see this render.',
          buttonText: 'Go to Home',
          onButtonClick: () => closeDialog(),
        });
        return;
      }
      if (parseInt(id) !== data?.id) {
        // TODO: we can do it based on render list data??? but it's only related to render page
        refreshData();
      }
    }, [id]);

    useEffect(() => {
      if (data?.images) {
        setSlidesByPass();
        // Only the edit passes are re-picked as the render's data comes back; a
        // Standard/Filmic/Color choice is the viewer's own, so it is left alone.
        const image = data?.images?.[activeIndex];
        const passValue = defaultPassFor(image, data);
        if (usesEditPasses(image) && pass !== passValue) {
          setPass(passValue);
        }
      }
      if ((data?.owner_organization && currentOrg) || allLineValues?.measurements?.length) {
        hasMeasureData();
      }
    }, [data, allLineValues]);

    useEffect(setSlidesByPass, [pass]);

    useEffect(() => {
      const passValue = defaultPassFor(data?.images?.[activeIndex], data);
      if (pass !== passValue) {
        setPass(passValue);
      }
    }, [activeIndex]);

    useEffect(async () => {
      if (activeCameraId) {
        const angleName = sidebarCards.find((a) => a?.id === activeCameraId)?.angle_name;
        if (!cameraNameParam || angleName) {
          if (angleName) {
            searchParams.set('cameraName', angleName);
          }
          setSearchParams(searchParams, { replace: true });
        }

        if (cameraNameParam) {
          const cameraIndex = sidebarCards.findIndex((a) => a?.id === activeCameraId);
          if (cameraIndex !== -1 && cameraIndex !== activeIndex) {
            setActiveIndex(cameraIndex);
          }
        }
      }
    }, [activeCameraId, sidebarCards]);

    // DPI the render was produced at. Used to stamp the edited image on
    // download, since the canvas export loses the source density metadata.
    function getCameraDpi(imageData) {
      return renderedData?.CameraData?.find((cam) => cam.id === imageData?.cam_id)?.dpi;
    }

    function getOriginalImage(imageData, getMainFile) {
      if (imageData?.is_tiff && !getMainFile) {
        return imageData?.is_filmic ? imageData?.extra_filmic_file : imageData?.extra_file
      }
      else {
        return imageData?.is_filmic ? imageData?.filmic_file : imageData?.file
      }
    }

    
    // Helper: Get sidebar thumbnail if status matches tagsConfig
    const getSidebarThumbnail = (imgId) => {
      const sidebarCard = sidebarCards.find(card => card.id === imgId);

      if (
        sidebarCard &&
        Object.prototype.hasOwnProperty.call(tagsConfig, sidebarCard.status)
      ) {
        return sidebarCard.thumbnail;
      }

      return null;
    };

    // Helper: Select thumbnail for each pass
    const getThumbnailByPass = (img, passType) => {
      const sidebarThumb = getSidebarThumbnail(img.id);
      if (sidebarThumb) return sidebarThumb;

      switch (passType) {
        case PASS.STANDARD:
          return img.is_tiff ? (img.extra_file || img.thumbnail) : (img.file || img.thumbnail);
        case PASS.FILMIC:
          return img.is_tiff ? (img.extra_filmic_file || img.thumbnail) : (img.filmic_file || img.thumbnail);
        case PASS.COLOR:
          return img.is_tiff ? (img.extra_color_pass_file || img.thumbnail) : (img.color_pass_file || img.thumbnail);
        // Post Edit IS the original with the edits drawn over it, so it shares the same base.
        // Falling through to `default` handed the carousel a thumbnail to sit under a full
        // resolution composite.
        case PASS.POST_EDIT:
        case PASS.ORIGINAL:
          return getOriginalImage(img);
        default:
          return img.thumbnail;
      }
    };

    function setSlidesByPass() {
      const currentImage = data?.images?.find(image => image.id === activeCameraId)
      const isImageEdited = Object.keys(currentImage?.edit_config || {})?.length
      const isFilmicImgType = data?.img_type === RENDER_IMAGE_TYPE.FILMIC;
      
      if (isImageEdited)
        setImageToolData(currentImage?.edit_config)
      else {
        setImageToolData(({ ...imageToolData, [EDIT_IMAGE_TOOLS.FILMIC_MODE]: { originalValue: isFilmicImgType ? 0 : 100, value: isFilmicImgType ? 0 : 100 } }))
      }

      if (pass === PASS.POST_EDIT) {
        if (!isImageEdited) {
          setPass(isFilmicImgType ? PASS.FILMIC : PASS.STANDARD);
        }
        dispatch(measureToolActions.setIsPassChangedToPostEdit(true));
      }

      /*
        Every pass fills the slides, Post Edit included - they are the image the carousel draws
        UNDER the edited composite, and `PreviewDisplay` won't even build that composite until
        `slides` has a length.

        Post Edit used to be left out, so slides were only ever filled as a side effect of some
        other pass having been active first. Stepping from one edited render to the next never
        leaves Post Edit - `refreshData` reselects it for an edited image, so nothing changes and
        no effect re-runs - and the empty array `resetState` just wrote stayed, leaving the
        carousel with nothing to show.

        Same array unless the values really changed: a fresh one on every pass would re-trigger
        the composite in `PreviewDisplay`, which is canvas work, not a re-render.
      */
      const nextSlides = _.map(data?.images, (img) => getThumbnailByPass(img, pass));
      setSlides((prev) => (_.isEqual(prev, nextSlides) ? prev : nextSlides));

      // if (pass === PASS.POST_EDIT) {
      //   // If prev image pass is selected to post edit and current image is not edited
      //   if (!isImageEdited) {
      //     setPass(isFilmicImgType ? PASS.FILMIC : PASS.STANDARD);
      //   }
      //   dispatch(measureToolActions.setIsPassChangedToPostEdit(true))
      // }
      // else if (pass === PASS.STANDARD) {
      //   setSlides(
      //     _.map(data?.images, (i) =>
      //       i.is_tiff ? i.extra_file || i.thumbnail : i.file || i.thumbnail
      //     )
      //   );
      // } else if (pass === PASS.FILMIC) {
      //   setSlides(
      //     _.map(data?.images, (i) =>
      //       i.is_tiff ? i.extra_filmic_file || i.thumbnail : i.filmic_file || i.thumbnail
      //     )
      //   );
      // } else if (pass === PASS.COLOR) {
      //   setSlides(
      //     _.map(data?.images, (i) =>
      //       i.is_tiff ? i.extra_color_pass_file || i.thumbnail : i.color_pass_file || i.thumbnail
      //     )
      //   );
      // } else if (pass === PASS.ORIGINAL) {
      //   setSlides(
      //     _.map(data?.images, (i) =>
      //       getOriginalImage(i)
      //     )
      //   );
      // }
    }

    function handleDownloadClick(e) {
      e.stopPropagation();

      if (isCuratorPage()) {
        trackDownloadImageClicked({
          variation_name: IMAGE_VARIATION_TYPE[pass],
          // TODO: add more data here
        });
      }

      if (isGuestUser()) {
        setDownloadXPos(isFullScreenOn || isOnboarding ? e.clientX : e.clientX - 232);
        setShowDownload(!showDownload);
        return;
      }

      setDownloadLoading(true);
      handlePermissionEvent(PERMISSION.DOWNLOAD_RENDER, (r) => {
        setDownloadLoading(false);
        if (r === undefined) {
          setDownloadXPos(isFullScreenOn || isOnboarding ? e.clientX : e.clientX - 232);
          setShowDownload(!showDownload);
        }
      })().finally(() => setDownloadLoading(false));
    }

    useEffect(() => {
      if (!showDownload) {
        setImageUrl([]);
      }
    }, [showDownload]);

    var zip = new JSZip();
    var zipName = data?.name;

    async function setAngleImageUrl(arr) {
      arr?.map((a, i) => {
        if (a?.file !== null) {
          const u = a?.file.split('/');
          const f = u[u.length - 1].split('?');
          const filename = f[0];

          setImageUrl((imageUrl) => [
            ...imageUrl,
            {
              id: a?.id,
              angle_name: a?.angle_name,
              imageType: hasPermission(PERMISSION.IMAGE_EDITOR) ? IMAGE_TYPE.ORIGINAL : IMAGE_TYPE.STANDARD,
              filename: filename,
              url: a?.file,
            },
          ]);
        }
        if (a?.filmic_file !== null) {
          const u = a?.filmic_file.split('/');
          const f = u[u.length - 1].split('?');
          const filename = f[0];

          setImageUrl((imageUrl) => [
            ...imageUrl,
            {
              id: a?.id,
              angle_name: a?.angle_name,
              imageType:  hasPermission(PERMISSION.IMAGE_EDITOR) ? IMAGE_TYPE.ORIGINAL : IMAGE_TYPE.FILMIC,
              filename: filename,
              url: a?.filmic_file,
            },
          ]);
        }
        if (a?.color_pass_file !== null) {
          const u = a?.color_pass_file.split('/');
          const f = u[u.length - 1].split('?');
          const filename = f[0];

          setImageUrl((imageUrl) => [
            ...imageUrl,
            {
              id: a?.id,
              angle_name: a?.angle_name,
              imageType: IMAGE_TYPE.COLOR,
              filename: filename,
              url: a?.color_pass_file,
            },
          ]);
        }
      });
    }

    const handleAllCameraRendersDownloadClick = async () => {
      setDownloadSingleImage(false);
      setDownloadLoading(true);

      let images = [];
      if (usesEditPasses(data?.images)) {
        for (let i = 0; i < data?.images.length; i++) {
          const currentImages = data?.images[i];
          const colorPassImage = currentImages?.color_pass_file;
          const isImageEdited = hasPostEditImage(currentImages)

          images.push(
            {
              id: currentImages?.id,
              angle_name: currentImages?.angle_name,
              imageType: IMAGE_TYPE.ORIGINAL,
              filename: `${data.name}_original.${renderedData?.render_extension || '.jpg'}`,
              url: getOriginalImage(currentImages, true),
            },
          );

          if (colorPassImage)
            images.push({
              id: currentImages?.id,
              angle_name: currentImages?.angle_name,
              imageType: IMAGE_TYPE.COLOR,
              filename: `${data.name}_color_pass.${renderedData?.render_extension || '.jpg'}`,
              url: colorPassImage,
            });

          if (isImageEdited) {
            const sourceImage = isFilmicImgType
              ? (currentImages?.extra_filmic_file || currentImages?.filmic_file)
              : (currentImages?.extra_file || currentImages?.file);
            let effectImageUrl;
            if (editedImages?.[currentImages?.id]) {
              effectImageUrl = editedImages?.[currentImages?.id];
            } else {
              const otherImage = isFilmicImgType
                ? (currentImages?.extra_file || currentImages?.file)
                : (currentImages?.extra_filmic_file || currentImages?.filmic_file);
              // A failure here must not abort the whole download - the original
              // and color pass images are already queued up.
              try {
                effectImageUrl = await handleDownloadEditedImage({
                  url: sourceImage,
                  imageToolData: currentImages?.edit_config,
                  otherImage,
                  colorPassImage,
                  title: data?.name,
                  returnFile: true,
                  dpi: getCameraDpi(currentImages),
                });
              } catch (error) {
                console.error('Failed to generate the edited image:', error);
              }
            }

            if (effectImageUrl)
              images.push({
                id: currentImages?.id,
                angle_name: currentImages?.angle_name,
                imageType: IMAGE_TYPE.POST_EDIT,
                // The editor re-encodes to jpeg or png, so the render's own
                // extension would mislabel the file - a tiff render's edit is
                // a png.
                filename: `${data.name}_post_edit.${postEditExtension(sourceImage)}`,
                url: effectImageUrl,
              });
          }
        }
        setImageUrl(images)
      } else {
        await setAngleImageUrl(data?.images);
      }
      //TODO Add image name and if as property mor mix panel event.
      Mixpanel.track(true, MxEvent.IMAGE_ALL_DOWNLOADED, {
        'Downloaded images info': data,
      });
    };

    const handleCurrentImageClick = async () => {
      if (isCuratorPage()) {
        trackDownloadCurrentImageSelected({
          variation_name: IMAGE_VARIATION_TYPE[pass],
          // TODO: add more data here
        });
      }

      setDownloadSingleImage(true);
      setDownloadLoading(true);

      //TODO Add image name and if as property mor mix panel event.
      Mixpanel.track(true, MxEvent.IMAGE_CURRENT_DOWNLOADED, {
        'Downloaded images info': data,
      });

      const currentImages = data?.images?.find(image => image.id === activeCameraId)
      if (usesEditPasses(currentImages)) {
        let images = []
        const colorPassImage = currentImages?.color_pass_file;

        images = [{
          id: currentImages?.id,
          angle_name: currentImages?.angle_name,
          imageType: IMAGE_TYPE.ORIGINAL,
          filename: `${data.name}_original.${renderedData?.render_extension || ".jpg"}`,
          url: getOriginalImage(currentImages, true),
        }]

        if (colorPassImage)
          images.push({
            id: currentImages?.id,
            angle_name: currentImages?.angle_name,
            imageType: IMAGE_TYPE.COLOR,
            filename: `${data.name}_color_pass.${renderedData?.render_extension || ".jpg"}`,
            url: colorPassImage,
          })


        if (hasPostEditImage(currentImages)){
          const sourceImage = isFilmicImgType
            ? (currentImages?.extra_filmic_file || currentImages?.filmic_file)
            : (currentImages?.extra_file || currentImages?.file);
          let effectImageUrl;
          if (editedImages?.[currentImages?.id]){
            effectImageUrl = editedImages?.[currentImages?.id]
          }
          else {
            const otherImage = isFilmicImgType
              ? (currentImages?.extra_file || currentImages?.file)
              : (currentImages?.extra_filmic_file || currentImages?.filmic_file);
            // A failure here must not abort the whole download - the original
            // and color pass images are already queued up.
            try {
              effectImageUrl = await handleDownloadEditedImage({ url: sourceImage, imageToolData: currentImages?.edit_config, otherImage, colorPassImage, title: data?.name, returnFile: true, dpi: getCameraDpi(currentImages) })
            } catch (error) {
              console.error('Failed to generate the edited image:', error);
            }
          }

          if (effectImageUrl)
            images.push({
              id: currentImages?.id,
              angle_name: currentImages?.angle_name,
              imageType: IMAGE_TYPE.POST_EDIT,
              // The editor re-encodes to jpeg or png, so the render's own
              // extension would mislabel the file - a tiff render's edit is
              // a png.
              filename: `${data.name}_post_edit.${postEditExtension(sourceImage)}`,
              url: effectImageUrl,
            })
          }

        setImageUrl(images)
        return
      }

      setAngleImageUrl(_.filter(data?.images, (a) => a.id === activeCameraId));
    };

    useEffect(async () => {
      if (isDownloadSingleImage && !includePasses) {
        imageUrl?.length !== 0 &&
          imageUrl.forEach(function (imgObj, i) {
            const fileUrl = imgObj.url;
            const angle_name = imgObj.angle_name;
            const imageType = imgObj.imageType;
            const ext = imgObj.filename.split('.').pop();

            const fileName = `${zipName}_${angle_name}_${imageType}.${ext}`;

            if (
              isMeasureToolActive &&
              document.getElementsByClassName('react-transform-component')?.length
            ) {
              const allComponent = document.getElementsByClassName('react-transform-component')[
                activeIndex
              ];
              const mainImage = document.querySelectorAll("#mainImage")[activeIndex];
              const measurementLayer = document.querySelectorAll(".measurement-layer-base")[activeIndex];
              if (allComponent) {
                const scale = mainImage.naturalWidth
                  ? mainImage.naturalWidth / mainImage.clientWidth
                  : 2;
                const styleObj = {
                  width: mainImage.naturalWidth || mainImage.clientWidth * scale,
                  height: mainImage.naturalHeight || mainImage.clientHeight * scale,
                  style: {
                    transform: 'scale(' + scale + ')',
                    transformOrigin: 'top left',
                    width: mainImage.clientWidth + 'px',
                    height: mainImage.clientHeight + 'px',
                  },
                };
                 // Ensure overlay is positioned correctly
                 measurementLayer.style.position = "absolute";
                 measurementLayer.style.top = "0";
                 measurementLayer.style.left = "0";
                const isTransparent = Boolean(renderedData?.is_transparent_bg);
                const captureOptions = isTransparent
                  ? { ...styleObj, bgcolor: 'rgba(0,0,0,0)' }
                  : styleObj;
                const captureAndDownload = () => {
                  if (!isTransparent) {
                    return domtoimage.toPng(allComponent, captureOptions).then((dataUrl) => {
                      downloadImgFromHtml(fileName, dataUrl);
                    });
                  }
                  // For transparent renders we need to remove the checkerboard CSS class
                  // and the dark container background before domtoimage reads the DOM.
                  // We restore both via requestAnimationFrame, which is guaranteed to fire
                  // AFTER domtoimage's internal cloneNode microtask but BEFORE the browser
                  // paints — so the user never sees the intermediate state (no flash).
                  const checkerEls = Array.from(allComponent.querySelectorAll('.lf-checker-png'));
                  const savedBg = allComponent.style.backgroundColor;
                  checkerEls.forEach((el) => el.classList.remove('lf-checker-png'));
                  allComponent.style.backgroundColor = 'transparent';
                  const capturePromise = domtoimage.toPng(allComponent, captureOptions);
                  const restore = () => {
                    checkerEls.forEach((el) => el.classList.add('lf-checker-png'));
                    allComponent.style.backgroundColor = savedBg;
                  };
                  requestAnimationFrame(restore);
                  return capturePromise
                    .then((dataUrl) => downloadImgFromHtml(fileName, dataUrl))
                    .catch(restore);
                };
                if (imageType === IMAGE_TYPE.STANDARD && pass === PASS.STANDARD) {
                  captureAndDownload();
                }
                if (imageType === IMAGE_TYPE.FILMIC && pass === PASS.FILMIC) {
                  captureAndDownload();
                }
                if (imageType === IMAGE_TYPE.COLOR && pass === PASS.COLOR) {
                  captureAndDownload();
                }
                if (imageType === IMAGE_TYPE.ORIGINAL && pass === PASS.ORIGINAL) {
                  captureAndDownload();
                }
                if (imageType === IMAGE_TYPE.POST_EDIT && pass === PASS.POST_EDIT) {
                  captureAndDownload();
                }
                setTimeout(() => { 
                 measurementLayer.style.position = "";
                 measurementLayer.style.top = "";
                 measurementLayer.style.left = "";
                }, 20);
              } else {
                errorToast('Something went wrong. Please try again.');
              }
            } else {
              const imagesGeneratedFrom = data?.is_product_builder
                ? 'Mattress Builder'
                : (_isAutomation || data?.is_automation)
                  ? 'Retail Automation'
                  : 'Curator';

              const matchingImage = data?.images?.find((img) => img.id === imgObj.id);
              const isImageEdited = Object.keys(matchingImage?.edit_config || {}).length > 0 ? 'Yes' : 'No';

              if (imageType === IMAGE_TYPE.STANDARD && pass === PASS.STANDARD) {
                download({
                  fileUrl,
                  fileName,
                  callback: () =>
                    trackDownloadImageSuccess({
                      variation_name: IMAGE_VARIATION_TYPE[pass],
                      'Images generated from': imagesGeneratedFrom,
                      'Is image edited': isImageEdited,
                    }),
                });
              }
              if (imageType === IMAGE_TYPE.FILMIC && pass === PASS.FILMIC) {
                download({
                  fileUrl,
                  fileName,
                  callback: () =>
                    trackDownloadImageSuccess({
                      variation_name: IMAGE_VARIATION_TYPE[pass],
                      'Images generated from': imagesGeneratedFrom,
                      'Is image edited': isImageEdited,
                    }),
                });
              }
              if (imageType === IMAGE_TYPE.COLOR && pass === PASS.COLOR) {
                download({
                  fileUrl,
                  fileName,
                  callback: () =>
                    trackDownloadImageSuccess({
                      variation_name: IMAGE_VARIATION_TYPE[pass],
                      'Images generated from': imagesGeneratedFrom,
                      'Is image edited': isImageEdited,
                    }),
                });
              }
              if (imageType === IMAGE_TYPE.ORIGINAL && pass === PASS.ORIGINAL) {
                download({
                  fileUrl,
                  fileName,
                  callback: () =>
                    trackDownloadImageSuccess({
                      variation_name: IMAGE_VARIATION_TYPE[pass],
                      'Images generated from': imagesGeneratedFrom,
                      'Is image edited': isImageEdited,
                    }),
                });
              }

              if (imageType === IMAGE_TYPE.POST_EDIT && pass === PASS.POST_EDIT) {
                // The edited blob is already in the source render's format with
                // its DPI stamped on, so this just saves it as-is.
                downloadEditedImage(
                  fileUrl,
                  fileName,
                  () =>
                    trackDownloadImageSuccess({
                      variation_name: IMAGE_VARIATION_TYPE[pass],
                      'Images generated from': imagesGeneratedFrom,
                      'Is image edited': isImageEdited,
                    }),
                );
              }
            }
          });

        await wait(500);
        setImageUrl([]);
        setDownloadLoading(false);
        setDownloadSingleImage(false);
        setShowDownload(false);

        return;
      }

      if (imageUrl?.length !== 0) {
        let count = 0;

        imageUrl.forEach(function (imgObj, i) {
          let url = imgObj.url;
          let angle_name = imgObj.angle_name;
          let imageType = imgObj.imageType;
          let ext = imgObj.filename.split('.').pop();

          let filename = `${zipName}_${angle_name}_${imageType}.${ext}`;

          JSZipUtils.getBinaryContent(url, function (err, data) {
            if (err) {
              throw err; // or handle the error
            }
            if (includePasses) {
              if (imageType === IMAGE_TYPE.STANDARD) {
                zip.folder(angle_name).file(filename, data, { binary: true });
              }
              if (imageType === IMAGE_TYPE.FILMIC) {
                zip.folder(angle_name).file(filename, data, { binary: true });
              }
              if (imageType === IMAGE_TYPE.COLOR) {
                zip.folder(angle_name).file(filename, data, { binary: true });
              }
              if (imageType === IMAGE_TYPE.POST_EDIT) {
                zip.folder(angle_name).file(filename, data, { binary: true });
              }
              if (imageType === IMAGE_TYPE.ORIGINAL) {
                zip.folder(angle_name).file(filename, data, { binary: true });
              }
            } else {
              if (imageType === IMAGE_TYPE.STANDARD && pass === PASS.STANDARD) {
                zip.folder(angle_name).file(filename, data, { binary: true });
              }
              if (imageType === IMAGE_TYPE.FILMIC && pass === PASS.FILMIC) {
                zip.folder(angle_name).file(filename, data, { binary: true });
              }
              if (imageType === IMAGE_TYPE.COLOR && pass === PASS.COLOR) {
                zip.folder(angle_name).file(filename, data, { binary: true });
              }
              if (imageType === IMAGE_TYPE.ORIGINAL && pass === PASS.ORIGINAL) {
                zip.folder(angle_name).file(filename, data, { binary: true });
              }
              if (imageType === IMAGE_TYPE.POST_EDIT && pass === PASS.POST_EDIT) {
                zip.folder(angle_name).file(filename, data, { binary: true });
              }
            }
            count++;
            if (count === imageUrl.length) {
              zip.generateAsync({ type: 'blob' }).then(function (content) {
                saveAs(content, zipName);
                setImageUrl([]);
                setDownloadLoading(false);
                setShowDownload(false);
                count = 0;
              });
            }
          });
        });
      }
    }, [imageUrl]);

    const downloadImgFromHtml = (fileName, dataUrl) => {
      const link = document.createElement('a');
      link.download = fileName;
      link.href = dataUrl;
      link.click();
    };

    async function refreshData({ data, str = '', resetData = false, showMainLoader = true } = {}) {
      if (loading) return;
      setLoading(true);
      showMainLoader && setPageLoading(true);

      if (resetData) setData(null);

      const param = new URLSearchParams();
      param.set('is_automation', _isAutomation.toString());
      if (render_type === 'archive') param.set('is_archived', 'true');

      const res = data || (await apiGetPreviewAndMainRender(id, null, null, `?${param}`));
      if (!isMountedRef.current) return;

      let ownerOrgFromApi;
      let orgFromApi;
      if (data && !res?.owner_organization) {
        const renderDetail = await apiGetPreviewAndMainRender(data?.id, null, null, `?${param}`);
        if (!isMountedRef.current) return;
        ownerOrgFromApi = renderDetail.owner_organization;
        orgFromApi = renderDetail.organization;
      }

      if (res) {
        setPageLoading(false);
        const dataToPass = JSON.parse(JSON.stringify(res));
        if (ownerOrgFromApi) {
          dataToPass['owner_organization'] = ownerOrgFromApi;
          dataToPass['organization'] = orgFromApi;
        }
        setData(dataToPass);
        if (data?.id) {
          const nextActiveInd = str === 'next' ? 0 : res?.images?.length - 1 || 0;
          setActiveCameraId(res?.images[nextActiveInd]?.id);
        } else {
          const cc = cameraNameParam && res?.images.find((a) => a?.angle_name === cameraNameParam);
          setActiveCameraId(cc?.id || res?.images[0]?.id);
        }
        setPass(defaultPassFor(res?.images?.[activeIndex], res));
        setMemberDetails(res?.member_details);
        onDataFetched?.(res);
      } else {
        setPageLoading(false);
        navigate(RENDERS_PREVIEWS_ROUTE_V2);
      }

      setLoading(false);

      const resCam = await apiGetRenderBasedOnProjectRenderId(data?.id || id);
      if (!isMountedRef.current) return;
      if (resCam.status) {
        setTitle(resCam?.data?.result?.render_name);
        setRenderedData(resCam?.data?.result);
      }
    }

    function handleFavorite() {
      setFavouriteLoading(true);
      const favorite = !data?.is_favourite;
      apiToggleFavorite(id, favorite, MODULE_TYPES.RENDER).then((res) => {
        if (res.status) {
          const updatedData = {
            ...data,
            is_favourite: favorite,
          };
          setData(updatedData);

          successToast(`${favorite ? 'Added to' : 'Removed from'} favourite`);
          setFavouriteLoading(false);
          onDataUpdated?.(updatedData);
        }
      });
    }

    async function toggleRenderArea(e, title) {
      const isVerified = await checkIfEmailIsVerifiedOrNotFromApi();
      if (title !== 'None' && !isVerified) return;

      if (isCuratorPage() && title === 'Buy Image') {
        trackBuyImageClicked({
          variation_name: IMAGE_VARIATION_TYPE[pass],
          // TODO: add more data here
        });
      }

      if ((title === 'Remove watermark' || title === 'Buy Image') && isGuestLogin) {
        setShowRemoveWatermarkPopup(true);
        dispatch(setSignupPopOpen(true));
        dispatch(setSignupPopOpenedFrom('high-resolution-image'));
        return;
      }

      if (title === 'Remove watermark' && !freeCredits && isFreemiumUser) {
        setShowPopup(true);
        return;
      }

      onBuyRemoveWatermark();
    }

    const onBuyRemoveWatermark = async () => {
      if (typeof renderedData === 'string') {
        errorToast(renderedData);
      } else {
        setRemoveOrBuyLoading(true);
        const resCam = await apiGetRenderBasedOnProjectRenderId(id);
        if (resCam.status) {
          setTitle(resCam?.data?.result?.render_name);
          setRenderedData(resCam?.data?.result);
          const updatedList = resCam?.data?.result?.CameraData?.map((c) => ({
            ...c,
            resoX: parseInt(c.resoX),
            resoY: parseInt(c.resoY),
          }));
          setCameraList(updatedList);
          setShowRender(true);
        }
        setRemoveOrBuyLoading(false);
      }
    };

    const handleEditClick = async () => {
      if (!checkIfMemberHaveEditorAccess()) return;

      if (isOldObj) {
        if (!data.old_zip_id || !data.is_editable) {
          errorToast('This render is not editable');
          return;
        }
      }

      if (!data.main_render) {
        errorToast('This render is not editable');
        return;
      }

      const image = data.images.find((image) => image.id === activeCameraId);
      const angleName = image?.angle_name;
      const cameraData = renderedData?.CameraData?.find(
        (camera) => camera.cameraName === angleName
      );

      Mixpanel.track(true, MxEvent.EDIT_IN_3D_IMAGE, {
        image_id: data?.id,
        image_name: data?.name,
        image_angle_name: angleName,
      });

      Mixpanel.track(true, MxEvent.CURATOR_STARTED, {
        'Curator project type': 'render',
        'Curator opened from': 'Edit button on render details page',
        'Render id': data?.id,
        'Render name': data?.name,
        'Render isFavourite': data?.is_favourite,
        'Render creator id': data?.member_details?.id,
        'Render creator name': data?.member_details?.name,
        'Render creator email': data?.member_details?.email,
        'Render created at': data?.created_at,
        'Render room': data?.room,
        'Render associate room': data?.associate_room,
      });

      let url = getCuratorRenderPreviewPath(data.id, cameraData?.cameraName, _isAutomation);

      if (data?.is_product_builder) {
        url = getCuratorRenderPreviewPathForMattress({ data, fallbackUrl: url });

        if (!url) errorToast('Project not found. It may have been deleted.');
      }

      if (url) windowOpen(url, '_blank');
    };

    const handleMagicToolClick = async () => {
      setMagicToolLoading(true);
      const payload = {
        other_info: JSON.stringify({
          ...currentUser?.user?.other_info,
          isMagicToolUsed: true,
        }),
      };
      const formData = objectToFormData(payload);
      await apiUpdateUserDetails(formData);
      updateUserData();

      const currentImage = _.filter(data?.images, (a) => a.id === activeCameraId)?.[0];
      const currentImageUrl =
        pass === '1'
          ? currentImage?.extra_file || currentImage?.file
          : pass === '2'
            ? currentImage?.extra_filmic_file || currentImage?.filmic_file
            : currentImage?.color_pass_file || currentImage.color_pass_file;

      const url = buildAIStudioUrl(
        'magic-tool',
        { renderFile: currentImageUrl },
        { source: AI_STUDIO_SOURCE.MAGIC_TOOL }
      );

      window.open(url, '_blank');
      setMagicToolLoading(false);
    };

    const handleRestore = async () => {
      setRestoreLoading(true);
      const payload = {
        is_archived: false,
      };

      let param = '?is_archived=true';
      if (data.is_automation) {
        param += '&is_automation=true';
      }

      const res = await apiEditRenderPreview(id, payload, null, null, param);
      if (res.status) {
        setData(res?.data);
        successToast('Render restored successfully.');

        if (res?.data.is_automation) {
          onClose?.();
          return;
        }

        history.replace(RENDER_DETAILS_V2.replace(':id', id));
      }
      setRestoreLoading(false);
    };

    const handleRetry = async () => {
      setRetryLoading(true);
      const res = await apiRetryRenderPreview(id);
      if (res.status) {
        refreshData();
      }
      setRetryLoading(false);
    };

    const handleReRenderImage = async () => {
      const currentImage = data?.images?.find(image => image.id === activeCameraId);
      const renderCamData = renderedData?.CameraData?.find(a => a.id === currentImage.cam_id);
      const renderCamList = [
        {
          id: renderCamData.id,
          resoX: renderCamData.resoX,
          resoY: renderCamData.resoY,
          dpi: renderCamData.dpi,
        }
      ]

      if(activeCameraId && currentImage?.id && renderCamList?.length > 0) {
        const payload = {
          count: 1, // Here, we are always sending the 1 angle image.
          render_name: data.name,
          render_extension: renderedData?.render_extension,
          render_camera: JSON.stringify(renderCamList),
          render_id: data.id,
          is_meta_data: renderedData.is_meta_data,
          is_shadow_on_floor: renderedData.is_shadow_on_floor,
          is_transparent_bg: renderedData.is_transparent_bg,
          is_water_mark: renderedData.is_water_mark,
          is_preview: renderedData.is_preview,
          is_main_render: renderedData.is_main_render,
          is_product_builder: renderedData.is_product_builder,
          is_rerender: true,
        };

        setReRenderLoading(true);
        const res = await apiCreateRender(payload);
        setReRenderLoading(false);
        if (res?.status) successToast(res?.message !== '' ? res?.message : 'Your image is being processed');
        else errorToast(res?.message);
      } else {
        errorToast('Unable to Re-Render image. Please try again!');
      }
    }

    // remove for beta
    // const handleHelp = () => {
    //   const ticketData = Object.assign({}, RAISE_TICKET_DEFAULTS.RENDERS_PREVIEWS_ANGLE)
    //   ticketData.title = ticketData.title.replace(RAISE_TICKET_PLACEHOLDER, sidebarCards.find(a => a?.id === activeCameraId)?.angle_name)

    //   if(!_.isEqual(ticketData, RAISE_TICKET_DEFAULTS.RENDERS_PREVIEWS)) {
    //     dispatch(createTicketModalActions.show(ticketData));
    //   }
    // }

    const renderNotReady = () =>
      warningToast('Your Render is not ready yet. You can download it when it is ready.');

    const isUserFromSameOrg = () => currentOrg === data?.organization;

    const isActiveCameraReady = () => {
      const currentCamStatus = sidebarCards.find((a) => a?.id === activeCameraId);
      return currentCamStatus?.status === RENDER_STATUS.STATUS_DONE;
    };

    const isActiveCameraFailed = () => {
      const currentCamStatus = sidebarCards.find((a) => a?.id === activeCameraId);
      return currentCamStatus?.status === RENDER_STATUS.STATUS_FAILED;
    };

    const isActiveCameraHasWatermark = () => {
      const cc = sidebarCards.find((a) => a?.id === activeCameraId);
      return cc?.is_image_watermark;
    };

    const isActiveCameraImageUnderFreeLicense = () => {
      const cc = sidebarCards.find((a) => a?.id === activeCameraId);
      return !cc?.is_paid_license;
    };

    const isPreviewOrUpload = data?.is_preview || data?.is_upload;

    const deactivateButton = {
      // isCurator: onClose ? true : false,
      footerButton: isActiveCameraReady() && !render_type && !isOldObj && !isGuestLogin,
      element: FooterButton,
      icon: BinIcon,
      title: isPreviewOrUpload ? 'Delete' : 'Archive',
      clickFunction: () => {
        if (memberDetails.id !== currentUser.user.id && !isAdminOrOwner(currentUser)) {
          errorToast('You cannot delete other members file', {
            toastId: 'DELETE_FORBIDDEN',
          });
          return;
        }

        const title = `Are you sure you want to ${isPreviewOrUpload
            ? `delete this ${data?.is_preview ? 'preview' : 'uploads'}`
            : 'archive this render'
          }?`;
        const description = isPreviewOrUpload
          ? 'Deleted items will be moved to trash.'
          : 'You can view the archived renders through filter panel.';

        const params = _isAutomation ? '?is_automation=true' : '';

        openInfoDialog({
          title,
          description,
          cancelButtonText: 'Cancel',
          cancelBtnColor: 'warning',
          okBtnColor: 'outline-dark',
          buttonText: isPreviewOrUpload ? 'Delete' : 'Archive',
          onButtonClick: async () => {
            const result = await apiArchiveRender({ id, params });
            if (result?.status) {
              const successMessage = data.is_preview
                ? `Preview has been successfully deleted`
                : data.is_upload
                  ? `Upload has been successfully deleted`
                  : 'Render havs been successfully archived';
              successToast(successMessage);

              if (onDeleteSuccess) {
                onDeleteSuccess();
              } else {
                dataListContext?.refetchList?.();
                navigate(RENDERS_PREVIEWS_ROUTE_V2);
              }
            }
          },
        });
      },
    };

    const handleMeasureToolBtnClick = async () => {
      setShowMeasureTool(!showMeasureTool);
    };

    const hasMeasureData = () => {
      let result = false;
      if (currentOrg === data?.owner_organization) {
        result = true;
      } else if (allLineValues?.measurements?.length) {
        result = true;
      } else {
        result = false;
      }
      if (result) {
        setIsMeasureDataPresent(result);
      }
    };

    const measureTool = {
      element: FooterButton,
      icon: DimensionToolIconV2,
      title: 'Add Dimensions',
      clickFunction: handleMeasureToolBtnClick,
      footerButton:
        isActiveCameraReady() &&
        !isAutomation &&
        isMeasureDataPresent &&
        !isGuestUser() &&
        !isGuestLogin,
      isDisabled: !isActiveCameraReady(),
      seq: 5,
      cardType,
      id: 'measureTool',
      iconProps: { style: { margin: '2px 0px', height: '20px', padding: '3px' } },
    };


    const getCurrentImageUrlForAI = async () => {
      const currentImage = data?.images?.find((a) => a.id === activeCameraId);
      if (!currentImage) return null;

      const isPostEdit = pass === PASS.POST_EDIT;
      const hasEdits = Object.keys(currentImage?.edit_config || {}).length > 0;

      // Only download + upload when post-edit pass is active and edits exist.
      if (isPostEdit && hasEdits) {
        // Session-scoped cache key: same source image + same edit_config will
        // always produce the same canvas output, so we can skip the render +
        // upload entirely if we've already done it during this page session.
        const cacheKey = `render-edit:${currentImage.id}:${JSON.stringify(
          currentImage.edit_config
        )}`;
        const cached = getCachedGenerativeAIUpload(cacheKey);
        if (cached) return cached;

        const sourceUrl = isFilmicImgType
          ? currentImage?.extra_filmic_file || currentImage?.filmic_file
          : currentImage?.extra_file || currentImage?.file;
        const otherImage = isFilmicImgType
          ? currentImage?.extra_file || currentImage?.file
          : currentImage?.extra_filmic_file || currentImage?.filmic_file;
        const colorPassImage = currentImage?.color_pass_file;

        // 1. Render the edited canvas to a blob URL (download in memory).
        const blobUrl = await handleDownloadEditedImage({
          url: sourceUrl,
          imageToolData: currentImage?.edit_config,
          otherImage,
          colorPassImage,
          title: data?.name,
          returnFile: true,
        });

        // 2. Convert the blob URL to an actual File.
        const safeName = `${data?.name || 'image'}_${currentImage?.angle_name || 'edited'}.jpg`;
        const file = await jpegFileFromBlobUrl(blobUrl, safeName);

        // 3. Upload via Lambda-signed S3 POST. The helper stores the resulting
        // URL under `cacheKey` so a subsequent call in this session is a no-op.
        return uploadGenerativeAIFile(file, safeName, { cacheKey });
      }

      // For every other pass, the rendered URL is already publicly accessible.
      if (pass === PASS.STANDARD) return currentImage?.extra_file || currentImage?.file;
      if (pass === PASS.FILMIC) return currentImage?.extra_filmic_file || currentImage?.filmic_file;
      if (pass === PASS.COLOR) return currentImage?.color_pass_file;
      if (pass === PASS.ORIGINAL) {
        return isFilmicImgType
          ? currentImage?.extra_filmic_file || currentImage?.filmic_file
          : currentImage?.extra_file || currentImage?.file;
      }
      return currentImage?.extra_file || currentImage?.file;
    };

    const handleEditImageToolBtnClick = async () => {
      dispatcher(measureToolActions.setLastClickedIsReset(false));
      const image = data?.images?.[activeIndex]
      const isFilmicImgType = data?.img_type === RENDER_IMAGE_TYPE.FILMIC;
      if (Object.keys(image?.edit_config)?.length){
        setImageToolData(image?.edit_config);
      }
      else if (pass != '5') {
        setImageToolData({
          [EDIT_IMAGE_TOOLS.COLOR_CORRECTION]: {value: 0, originalValue: 0},
          [EDIT_IMAGE_TOOLS.FILMIC_MODE]: { originalValue: isFilmicImgType ? 0 : 100, value: isFilmicImgType ? 0 : 100 } 
        });
      }
      setShowEditImageTool(!showEditImageTool);
      trackClickEvent('Edit Image', {
        file_name:`${data?.name}_${image?.angle_name}`,
        module_name:"Image Editor"
      })
    };

    const reRenderButton = {
      element: FooterButton,
      icon: ReRenderIcon,
      title: 'Re-Render',
      clickFunction: handleReRenderImage,
      footerButton: isActiveCameraReady() && !isGuestUser() && (canAccessLiveOnApp() || isEditor),
      isDisabled: !isActiveCameraReady(),
      seq: 1,
      cardType,
      id: 'rerender_image',
      loading: reRenderLoading,
      iconProps: { style: { height: '24px', width: '24px', padding: '0px' } },
    };

    const editImageTool = {
      element: FooterButton,
      icon: EditIconV3,
      title: 'Edit Image',
      clickFunction: handleEditImageToolBtnClick,
      footerButton:
        hasPermission(PERMISSION.IMAGE_EDITOR) &&
        isActiveCameraReady() &&
        // !isAutomation &&
        !isGuestUser() &&
        !isGuestLogin,
      isDisabled: !isActiveCameraReady(),
      seq: 0,
      cardType,
      id: 'edit_image',
    };

    const editWithAITool = {
      element: EditWithAIFooterButton,
      title: 'Edit with AI',
      icon: MagicToolIcon,
      footerButton:
        isActiveCameraReady() &&
        !isGuestUser() &&
        !isGuestLogin,
      isDisabled: !isActiveCameraReady(),
      isDisabledCallback: renderNotReady,
      getImageUrl: getCurrentImageUrlForAI,
      seq: 0.5,
      cardType,
      id: 'edit_with_ai',
      data:{ data, cameraList, activeIndex, slides, activeCameraId }
    };

    const isImageFromBuilder = () => {
      return data?.is_product_builder;
    };

    const showRenderOrDownload = {
      element: Download,
      footerButton: isActiveCameraReady(),
      // footerButton:
      //   (isActiveCameraReady() &&
      //     (_isAutomation ||
      //       (!isActiveCameraHasWatermark() && !isActiveCameraImageUnderFreeLicense())) &&
      //     !render_type) ||
      //   isTutorialExperience,
      isDisabled: !isActiveCameraReady(),
      isDisabledCallback: renderNotReady,
      title: 'Download',
      iconSrc: DOWNLOAD_ICON,
      loading: downloadLoading,
      clickFunction: (e) => handleDownloadClick(e),
      seq: 6,
    };
    // (!_isAutomation && data?.is_preview) ? {
    //   element: FooterButton,
    //   footerButton: false, //isActiveCameraReady() && !render_type && !data?.is_automation,
    //   title: 'Render',
    //   icon: FinalRenderIcon,
    //   clickFunction: (e) => toggleRenderArea(e),
    //   seq: 1,
    // } :

    const actions = [
      reRenderButton,
      {
        ...measureTool,
      },
      {
        element: FooterButton,
        title: 'Remove watermark',
        footerButton:
          isActiveCameraReady() &&
          isActiveCameraHasWatermark() &&
          !isAutomation &&
          !isTutorialExperience &&
          (!isGuestUser() || isGuestLogin) &&
          !isImageFromBuilder(),
        parentClassName: 'withoutIconBtn',
        clickFunction: (e) => toggleRenderArea(e, 'Remove watermark'),
        loadingOverText: removeOrBuyLoading,
        parentDivStyle: {
          minWidth: 179.44,
        },
        cardType,
        seq: 1,
      },
      {
        element: FooterButton,
        title: 'Buy Image',
        footerButton:
          isActiveCameraReady() &&
          !isActiveCameraHasWatermark() &&
          isActiveCameraImageUnderFreeLicense() &&
          !isAutomation &&
          !isTutorialExperience &&
          !isGuestUser() &&
          !isImageFromBuilder(),
        parentClassName: 'withoutIconBtn',
        clickFunction: (e) => toggleRenderArea(e, 'Buy Image'),
        loadingOverText: removeOrBuyLoading,
        parentDivStyle: {
          minWidth: 116.6,
        },
        cardType,
        seq: 2,
      },
      {
        ...showRenderOrDownload,
      },
      {
        element: FooterButton,
        title: 'Retry',
        footerButton:
          isActiveCameraFailed() &&
          isUserFromSameOrg() &&
          !render_type &&
          !isGuestUser() &&
          !isGuestLogin &&
          !isImageFromBuilder(),
        icon: RetryIcon,
        clickFunction: handleRetry,
        loading: retryLoading,
        cardType,
        seq: 3,
      },
      !isGuestUser() &&
        !isUpload && {
          element: FooterButton,
          title: 'Edit in 3D',
          footerButton: !_isAutomation
            ? true && isUserFromSameOrg() && !render_type
            : isUserFromSameOrg() && !render_type && !isOldObj,
          icon: ImagineLogo,
          clickFunction: handleEditClick,
          seq: 0, // keeping it always first
        },
      editImageTool,
      editWithAITool,
      // Commented as per DEV-40783 ticket
      // !isGuestUser() && {
      //   element: FooterButton,
      //   title: 'Magic Tool',
      //   footerButton: true && !isGuestUser() && !isGuestLogin && !isImageFromBuilder(),
      //   icon: MagicToolIcon,
      //   clickFunction: handleMagicToolClick,
      //   hoverComponent: currentUser?.user?.other_info?.isMagicToolUsed ? null : (
      //     <div className="new-tag" style={{ height: '25px', fontSize: '0.7rem' }}>
      //       NEW
      //     </div>
      //   ),
      //   loading: magicToolLoading,
      //   iconProps: { style: { margin: '0.5px 0' } },
      //   seq: 4,
      // },
      {
        element: SharePopup,
        footerButton:
          isActiveCameraReady() &&
          !render_type &&
          !isGuestUser() &&
          !isGuestLogin &&
          !isImageFromBuilder(),
        icon: ShareIcon,
        title: 'Share',
        setShareModal: setShareModal,
        seq: 7,
        modelType: 6,
      },
      {
        element: FooterButton,
        footerButton: isActiveCameraReady() && !render_type && !isGuestUser() && !isGuestLogin,
        icon: CollectionIcon,
        title: 'Add to Collection',
        // onSuccess: () => console.log('successfully added to collections'),
        // cardType,
        clickFunction: () =>
          addToCollection({
            modelType: MODEL_TYPES.PROJECTRENDER,
            items: [data],
          }),
        // id: id,
        seq: 8,
      },
      {
        element: FooterButton,
        footerButton:
          isActiveCameraReady() &&
          !render_type &&
          !isGuestUser() &&
          !isGuestLogin &&
          !isImageFromBuilder(),
        title: 'Favorite',
        icon: data?.is_favourite ? HeartIcon : HeartLineIcon,
        clickFunction: handleFavorite,
        is_favourite: data?.is_favourite,
        loading: favouriteLoading,
        seq: 9,
      },
      {
        element: FooterButton,
        footerButton: isActiveCameraReady() && !render_type,
        icon: FullScreenIcon,
        title: 'Full Screen',
        seq: 10,
      },
      isActiveCameraReady() &&
      !render_type &&
      !isGuestUser() && {
        ...deactivateButton,
        seq: 11,
      },
      {
        element: FooterButton,
        footerButton: isArchived && !isGuestUser() && !isGuestLogin && !isImageFromBuilder(),
        title: 'Restore',
        icon: RestoreIcon,
        clickFunction: handleRestore,
        cardType,
        loading: restoreLoading,
        seq: 12,
      },
      {
        element: FooterButton,
        footerButton: false, // remove for beta
        title: 'Help',
        icon: HeadsetIcon,
        // clickFunction: handleHelp, // remove for beta
        cardType,
        seq: 13,
      },
    ].filter(Boolean);

    // Image Tool functionality
    function handleImageToolItemClicked(id){
      setImageToolData({...imageToolData, active: id})
    }
  
    // Image Tool options
    const imageToolActions = EDIT_IMAGE_TOOL_OPTIONS?.map((item, index) => ({
      element: FooterButton,
      title: item,
      clickFunction: () => handleImageToolItemClicked(item),
      seq: index,
      cardType,
      footerButton: true,
      id: item,
      iconProps: { style: { margin: '2px 0px', height: '20px', padding: '3px' } },
      active: imageToolData?.active === item
    }))

    const updatedAt = useMemo(() => {
      if (!data?.updated_at) return null;
      return new Date(data?.updated_at).getTime();
    }, [data?.updated_at]);

    const handleClose = () => {
      const path = location?.pathname?.split('/');
      if (
        path
          ?.filter((a, i) => i !== path?.length - 1)
          .join('/')
          .includes(MODULE_TYPES.RENDERS_PREVIEWS_ROUTE_V2)
      ) {
        if (window.history.length) {
          const url = window.$previousURL;
          navigate(url || RENDERS_PREVIEWS_ROUTE_V2);
          setTimeout(() => {
            window.$restrictFilter = null;
            handleScrollPage();
          }, 500);
          return;
        }
        navigate(RENDERS_PREVIEWS_ROUTE_V2);
      }
      setTimeout(() => {
        window.$restrictFilter = null;
        handleScrollPage();
      }, 500);

      if (onClose) {
        onClose();
        return;
      }

      const params = new URLSearchParams(location.search);
      params.delete('cameraName');
      params.delete('render_type');
      params.delete('automation');
      params.delete('isOnboarding');

      dataListContext?.refetchList?.();

      if (location.pathname.startsWith('/collection')) {
        navigate(getCollectionPath(collectionId, { params }));
      } else if (location.pathname.startsWith(MY_FILES_SHARED_FILES_ROUTE)) {
        navigate(MY_FILES_SHARED_FILES_ROUTE + '?' + params);
      } else {
        navigate(RENDERS_PREVIEWS_ROUTE_V2 + '?' + params);
      }
    };

    const hasMetadata = renderedData?.roomMetadata
      ? Object.values(renderedData?.roomMetadata || {}).length > 0
      : false;

    const hideDownloadActions = () => {
      setShowDownload(false);
      setIncludePasses(false);
    };

    useEffect(() => {
      window.addEventListener('keydown', hideDownloadActions);
      window.addEventListener('click', hideDownloadActions);
      dispatcher(measureToolActions.setIsStampingAllowed(false));
      return () => {
        setTitle(parentPageTitle);
        window.addEventListener('keydown', hideDownloadActions);
        window.removeEventListener('click', hideDownloadActions);
        setTimeout(() => {
          window.$restrictFilter = null;
        }, 500);
      };
    }, []);

    useEffect(() => {
      const fetchData = async () => {
        const angle = sidebarCards.find((a) => a?.id === activeCameraId);
        let name = angle?.angle_name;

        if (angle?.file && name) {
          try {
            const isTiff = angle.is_tiff;
            let file = angle.file;
            let fileForSize = angle.file;

            if (pass === PASS.STANDARD) {
              file = angle.file;
              fileForSize = angle.file;
              if (isTiff) fileForSize = angle.extra_file;
            } else if (pass === PASS.FILMIC) {
              file = angle.filmic_file;
              fileForSize = angle.filmic_file;
              if (isTiff) fileForSize = angle.extra_filmic_file;
            } else if (pass === PASS.COLOR) {
              file = angle.color_pass_file;
              fileForSize = angle.color_pass_file;
              if (isTiff) fileForSize = angle.extra_color_pass_file;
            }
            if (file) {
              const fileUrl = file.split('?')?.[0]?.split('.');
              const extension = fileUrl[fileUrl.length - 1];

              const imgDetails = await getImageDetails(fileForSize);
              if (!isMountedRef.current) return;
              const { width, height } = imgDetails;
              name = `${name}.${extension} (${width}*${height})`;
            }
          } catch (error) {
            console.error('Error fetching image details:', error);
          }
        }

        if (!isMountedRef.current) return;
        setActiveCameraName(name);
      };

      fetchData();
    }, [sidebarCards, activeCameraId, slides, pass]);

    const resetMeasurementLines = () => {
      const initialLineValues = {
        measurements: [],
        widthInPx: 0,
        heightInPx: 0,
      };
      dispatcher(measureToolActions.setImageMeasurementData(null));
      dispatcher(measureToolActions.setAllLineValues(initialLineValues));
      dispatcher(measureToolActions.setIsMeasureToolActive(false));
      dispatcher(measureToolActions.setMeasureToolStyle(initialMeasureToolStyle));
    };

    const isMatchingUrl = (fullUrl) => {
      if (!fullUrl) {
        return false
      }
      const path = fullUrl?.split('?')?.[0]; // remove query string
      const regex = /^\/collections\/[^/]+$/;
      return regex.test(path);
    };

    const handleNextClick = async () => {
      // TODO: add check if we're on renders preview page ???? or pass some argument in query which determines which pagination list we want to use
      // TODO: when page loads we need some time to load results for renders/previews page -> we need to wait for event of some kind or something else
      resetMeasurementLines();
      dispatcher(measureToolActions.setLastClickedIsReset(false));
      if (!dataListContext) {
        return true;
      }

      if (activeIndex !== slides?.length - 1) {
        // allow to go to next slide
        return true;
      }

      let renderList = dataListContext.selectList(getAppState());
      if (collectionList?.list?.length && isMatchingUrl(window.$previousURL)) {
        renderList = collectionList?.list;
      }

      const currentIndex = renderList.findIndex((item) => item.id === data.id);
      const nextIndex = currentIndex === -1 ? 0 : currentIndex + 1;
      let nextRender = renderList[nextIndex];

      if (!nextRender && !dataListContext.hasMore && !isMatchingUrl(window.$previousURL)) {
        return activeIndex !== slides?.length - 1;
      }
      if (
        !nextRender &&
        !collectionList.hasMore &&
        collectionList?.list?.length &&
        isMatchingUrl(window.$previousURL)
      ) {
        return activeIndex !== slides?.length - 1;
      }

      if (!nextRender) {
        if (collectionList?.hasMore && isMatchingUrl(window.$previousURL)) {
          setPageLoading(true);
          await collectionList.fetchMoreData();
          setPageLoading(false);
          renderList = selectCreatedCollectionList(getAppState())?.list;
          nextRender = renderList[nextIndex];
        } else {
          setPageLoading(true);
          await dataListContext.fetchMoreData();
          setPageLoading(false);
          renderList = dataListContext.selectList(getAppState());
          nextRender = renderList[nextIndex];
        }
      }

      const params = new URLSearchParams(location.search);
      params.delete('cameraName');
      resetState();
      refreshData({ data: nextRender, str: 'next', resetData: true });
      setActiveIndex(0);
      setActiveCameraId(nextRender.images[0].id);

      if (onRenderSwitch) {
        onRenderSwitch(nextRender);
      } else {
        const url = (RENDER_DETAILS_V2 + `?${params}`).replace(':id', nextRender.id);
        history.replace(url);
        navigate(url);
      }
      return false;
    };

    const handlePrevClick = async () => {
      // TODO: add check if we're on renders preview page ???? or pass some argument in query which determines which pagination list we want to use
      // TODO: when page loads we need some time to load results for renders/previews page -> we need to wait for event of some kind or something else
      resetMeasurementLines();
      dispatcher(measureToolActions.setLastClickedIsReset(false));
      if (!dataListContext) {
        return true;
      }

      if (activeIndex !== 0) {
        // allow to go to prev slide
        return true;
      }

      let renderList = dataListContext.selectList(getAppState());
      if (collectionList?.list?.length && isMatchingUrl(window.$previousURL)) {
        renderList = collectionList?.list;
      }
      const currentIndex = renderList.findIndex((item) => item.id === data.id);

      // let nextIndex = currentIndex === -1 ? 0 : currentIndex - 1;
      // nextIndex = Math.max(nextIndex, 0);
      let prevRender = renderList[currentIndex - 1];

      if (!prevRender) {
        return activeIndex !== 0;
      }

      const params = new URLSearchParams(location.search);
      params.delete('cameraName');
      resetState();
      refreshData({ data: prevRender, str: 'previous', resetData: true });

      const newActiveIndex = prevRender.images.length - 1;
      setActiveIndex(newActiveIndex);
      setActiveCameraId(prevRender.images?.[newActiveIndex]?.id);

      if (onRenderSwitch) {
        onRenderSwitch(prevRender);
      } else {
        const url = (RENDER_DETAILS_V2 + `?${params}`).replace(':id', prevRender.id);
        history.replace(url);
        navigate(url);
      }
      return false;
    };

    const hasData = Boolean(data);
    const isTransparentBg = Boolean(renderedData?.is_transparent_bg);
    let hideNextButton = hasData && data.images?.length < 2;
    let hidePrevButton = hasData && data.images?.length < 2;

    if (dataListContext) {
      const list = dataListContext.list;
      const lastRender = list[list.length - 1];
      hideNextButton =
        Boolean(lastRender) &&
        Boolean(data) &&
        lastRender.id === data.id &&
        !dataListContext.hasMore &&
        data?.images?.length - 1 === activeIndex;

      const firstRender = list[0];
      hidePrevButton =
        Boolean(firstRender) && Boolean(data) && firstRender.id === data.id && activeIndex === 0;
    }

    const setIsMeasureToolActive = (val) => {
      if (currentOrg === data?.owner_organization) {
        dispatcher(measureToolActions.setIsMeasureToolActive(val));
      } else {
        dispatcher(measureToolActions.setIsMeasureToolActive(!isMeasureToolActive));
      }
    };

    const showNonCommericalText =
      isActiveCameraReady() &&
      !isAutomation &&
      (isActiveCameraHasWatermark() || isActiveCameraImageUnderFreeLicense());

    const disablePreNextWhenOtherModalOpen =
      isCollectionModelActive ||
      showDownload ||
      showRender ||
      isGamifiedDialogOpen ||
      isShareImageModalOpen ||
      shareModal ||
      infoDialogOpen;

      const slidesToPass = useMemo(() => {
        return slides?.filter((data) => data);
      }, [slides]);

    return (
      <>
        <Loader
          portal
          loading={pageLoading}
          position="fixed"
          zIndex={4000}
          backdrop
          backdropColor="rgba(255, 255, 255, 0)"
        />
        <Preview
          id={data?.id}
          title={data?.name}
          isFilmic={data?.img_type === RENDER_IMAGE_TYPE.FILMIC}
          isEditImageTool={showEditImageTool}
          setIsEditImageTool={setShowEditImageTool}
          imageToolData={imageToolData}
          setImageToolData={setImageToolData}
          activeCameraName={activeCameraName}
          actions={showEditImageTool ? imageToolActions : data ? actions : []}
          isTutorialExperience={isTutorialExperience}
          onClose={handleClose}
          showNonCommericalText={showNonCommericalText}
          loading={loading}
          updatedAt={updatedAt}
          created_at={data?.updated_at}
          userName={userName || null}
          sidebarCards={sidebarCards}
          slides={slidesToPass}
          activeIndex={activeIndex}
          setActiveIndex={setActiveIndex}
          activeCameraId={activeCameraId}
          setActiveCameraId={setActiveCameraId}
          passOptions={isActiveCameraReady() && !isOnboarding && passOptions}
          pass={pass}
          editedImages={editedImages}
          setEditedImages={setEditedImages}
          theme={theme}
          refreshData={refreshData}
          setPass={setPass}
          isTransparentBg={isTransparentBg}
          memberDetails={memberDetails}
          sidebarProps={showEditImageTool && isAutomation ? `${{...sidebarProps , className: `${sidebarProps.className} 'opacity-0'}` }}` : sidebarProps}
          previewProps={previewProps}
          hideAutoEraseWarning={hideAutoEraseWarning}
          onNextClick={handleNextClick}
          onPrevClick={handlePrevClick}
          showPopup={showPopup}
          setShowPopup={setShowPopup}
          onBuyRemoveWatermark={onBuyRemoveWatermark}
          editImageLoading={editImageLoading}
          setEditImageLoading={setEditImageLoading}
          hideNextButton={
            hideNextButton ||
            isOnboarding ||
            measureToolLoading ||
            loading ||
            (isMeasureToolActive && downloadLoading)
          }
          hidePrevButton={
            hidePrevButton ||
            isOnboarding ||
            measureToolLoading ||
            loading ||
            (isMeasureToolActive && downloadLoading)
          }
          disablePreNextWhenOtherModalOpen={disablePreNextWhenOtherModalOpen}
          setFullScreenOn={setFullScreenOn}
          downloadLoading={downloadLoading}
          isMeasureToolEditable={currentOrg === data?.owner_organization}
          showMeasureTool={showMeasureTool}
          toggleOffMeasureTool={(val) => setShowMeasureTool(val)}
          resetLines={() => resetMeasurementLines()}>
          {showDownload && (
            <div
              className="download-popup text-light"
              style={{ left: downloadXPos - 170 }}
              onClick={(e) => e.stopPropagation()}>
              <button role="button" onClick={handleCurrentImageClick} className="">
                Current Image
              </button>
              {sidebarCards.length > 1 && !isMeasureToolActive && (
                <button
                  role="button"
                  disabled={data?.status !== RENDER_STATUS.STATUS_DONE}
                  className={cx(data?.status !== RENDER_STATUS.STATUS_DONE && 'disabled')}
                  onClick={() => handleAllCameraRendersDownloadClick()}>
                  All Camera Renders
                </button>
              )}
              {!isTutorialExperience && !isMeasureToolActive && !isPreviewOrUpload && (
                <>
                  <hr className="m-0 p-0" />
                  <button className="d-flex justify-content-between noAction">
                    <div className="">
                      <a>Include Passes</a>
                    </div>
                    <Form.Check
                      type="switch"
                      id="custom-switch"
                      value={includePasses}
                      checked={includePasses}
                      onChange={(e) => {
                        setIncludePasses(e.target.checked);
                        if (e.target.checked) {
                          trackDownloadIncludePassesSelected({
                            variation_name: IMAGE_VARIATION_TYPE[pass],
                            // TODO: add more data here
                          });
                        }
                      }}
                    />
                  </button>
                </>
              )}
            </div>
          )}
          {showMeasureTool && !downloadLoading && !loading && (
            <MeasureToolContainer
              allStyleSectionData={allStyleSectionData}
              isMeasureToolEditable={currentOrg === data?.owner_organization}
              isMeasureToolActive={isMeasureToolActive}
              activeCameraId={activeCameraId}
              lineValues={lineValues}
              currentCard={sidebarCards[activeIndex]}
              toggleOffMeasureTool={(val) => setShowMeasureTool(val)}
              setIsMeasureToolActive={(val) => setIsMeasureToolActive(val)}
              isFullScreen={isFullScreenOn}
            />
          )}
        </Preview>
        {showRender &&
          data !== undefined &&
          data !== null &&
          data?.images?.length > 0 &&
          cameraList !== undefined &&
          cameraList !== null &&
          cameraList?.length > 0 && (
            <RenderPageDialog
              renderId={id}
              renderName={renderedData?.render_name}
              renderExtension={renderedData?.render_extension}
              isMetaData={renderedData?.is_meta_data}
              isImageWatermark={isActiveCameraHasWatermark()}
              isShadowOnFloor={renderedData?.is_shadow_on_floor}
              isTransparentBg={renderedData?.is_transparent_bg}
              isWatermark={renderedData?.is_water_mark}
              isPaidLicense={!isActiveCameraImageUnderFreeLicense()}
              cameraData={cameraList}
              showRender={showRender}
              setShowRender={setShowRender}
              hasMetadata={hasMetadata}
              onRenderSuccess={onRenderSuccess}
            />
          )}
        {!ignoreAddToCollectionPopup && <AddToCollectionPopup />}
        <InviteModal />
        <FinalProgressModal />
        <ShareImage image={sidebarCards?.[activeIndex]?.thumbnail} />
      </>
    );
  }
);

export default RenderDetails;
